import { DragDropContext as Context } from "react-beautiful-dnd";
export default Context;